import { BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString, BaseTLTableBase, GeneralTermService, Watch } from "../../../Infrastructure/CorBase/CoreBase";
import { PricelistService, PricelistFilter, TariffService, PricelistTemplateService, PricelistTemplateFilter } from "../../../Services/AccBase/AllAccServices";

export default abstract class PricelistListBase extends BaseTLTableComponent {

	protected pricelistService: PricelistService = new PricelistService();
	protected pricelistTemplateService: PricelistTemplateService = new PricelistTemplateService();
	protected tariffService: TariffService = new TariffService();
	protected generalTermService: GeneralTermService = new GeneralTermService();


//	typeEnums: any[] = [];
	items: any[] = [];
	items2: any[] = [];
	//defaultEnum = '1';
	idType = '';

	typeTariffs: any[] = [];
	defaultTariff = '1';
	idTariff = '';

	typeTerms: any[] = [];
	defaultTerms = '1';
	idTerm = '';

	pricelistTemplate: any[] = [];

	callActionClick() {
		this.isBusy = true;
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();
		this.itemsSelected = null;
		(this.$refs.pricelistTable as BaseTLTableBase).clearSelected();	
	}	



	formData = {
		id: 0,
		name: '',
		description: '',
		identifier: '',
		vat:0,
		isDaily: false,
		isFromTo: false,
		idTariff: 0,
		idGeneralTermsAndConditions: 0,
		idGeneralTermsAndConditionsName: '',
		idTariffName: '',
		idItemType: 0,
		idItemTypeName: '',
		priceDay: 0,
		priceMonth: 0,
		amount: 0,
		amountFrom: 0,
		amountTo: 0,
		unit: '',
		isDeleted: false
	};

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.pricelistService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('pricelist.messageQuestionMain').toString();

	deleteItem = 0;
	protected showAlertBeforeDeleteBase(itemsSelected: any) {	
		this.deleteItem = Number(itemsSelected);
		var idTariff = this.filters.filter((c: any) => c.key == "idTariff")[0].value;
		var idGeneralTermsAndConditions = this.filters.filter((c: any) => c.key == "idGeneralTermsAndConditions")[0].value;
		this.oldIdTariff = idTariff;
		this.oldIdTerm = idGeneralTermsAndConditions;
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('pricelist.messageQuestionMain').toString());		
	}

	protected setFields() {
		this.fields = [
			//{ key: 'idTariff', label: 'idTarif', sortable: true, class: 'text-center' },
			//{ key: 'idGeneralTermsAndConditions', label: 'IdGeneralTermsAndConditions', sortable: true, class: 'text-center' },
			//{ key: 'idItemType', label: this.$t('pricelist.fieldIdentif'), trans: 'pricelist.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('pricelist.fieldName'), trans: 'pricelist.fieldName', sortable: true, class: 'text-left' },
			{ key: 'idTariffName', label: this.$t('pricelist.fieldTariffName'), trans: 'pricelist.fieldTariffName', sortable: true, class: 'text-center' },
			{ key: 'idGeneralTermsAndConditionsName', label: this.$t('pricelist.fieldGeneralTermsAndConditions'), trans: 'pricelist.fieldGeneralTermsAndConditions', sortable: true, class: 'text-center' },
			{ key: 'idItemTypeName', label: this.$t('pricelist.fieldItemTypeName'), trans: 'pricelist.fieldItemTypeName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('pricelist.fieldDescription'), trans: 'pricelist.fieldDescription', sortable: true, visible: true, class: 'text-center' },

			{ key: 'identifier', label: this.$t('pricelist.fieldIdentifier'), trans: 'pricelist.fieldIdentifier', sortable: true, visible: true, class: 'text-center' },
			{ key: 'priceDay', label: this.$t('pricelist.fieldPriceDay'), trans: 'pricelist.fieldPriceDay', sortable: true, visible: true, class: 'text-center' },
			{ key: 'priceMonth', label: this.$t('pricelist.fieldPriceMonth'), trans: 'pricelist.fieldPriceMonth', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amount', label: this.$t('pricelist.fieldAmount'), trans: 'pricelist.fieldAmount', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amountFrom', label: this.$t('pricelist.fieldAmountFrom'), trans: 'pricelist.fieldAmountFrom', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amountTo', label: this.$t('pricelist.fieldAmountTo'), trans: 'pricelist.fieldAmountTo', sortable: true, visible: true, class: 'text-center' },

			{ key: 'unit', label: this.$t('pricelist.fieldUnit'), trans: 'pricelist.fieldUnit', sortable: true, visible: true, class: 'text-center' },


			{ key: 'description', label: this.$t('pricelist.fieldDescription'), trans: 'pricelist.fieldDescription', sortable: true, visible: true, class: 'text-center' },

			{ key: 'actions', label: this.$t('pricelist.fieldAction'), trans: 'pricelist.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{
					key: 'idTariff', label: this.$t('pricelist.fieldTariffName'), trans: 'pricelist.fieldTariffName', selected: true, value: this.defaultTariff , default: this.defaultTariff, type: 'text', useOwnEnumsSend: true,
					useOwnEnumsSendArray: this.typeTariffs, useEnum: true, refItem: 'idTariff', showAnyTime: true, lang: this.$store.state.currentLanguage
				},
				{
					key: 'idGeneralTermsAndConditions', label: this.$t('pricelist.fieldTariffName'), trans: 'pricelist.fieldTariffName', selected: true, value: this.defaultTerms, default: this.defaultTerms, type: 'text', useOwnEnumsSend: true,
					useOwnEnumsSendArray: this.typeTerms, useEnum: true, refItem: 'idGeneralTermsAndConditions', showAnyTime: true, lang: this.$store.state.currentLanguage
				},
				{ key: 'name', label: this.$t('pricelist.fieldName'), trans: 'pricelist.fieldName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('pricelist.fieldDescription'), trans: 'pricelist.fieldDescription', selected: false, value: null, type: 'text' },
			];
		}
	}
	//TODO
	loadDefault(idType: string) {
		if (Number(idType) == 0) {
			this.idType = this.defaultTariff;
		

		}
	}

	showCreatePriceList() {
		var idTariff = this.filters.filter((c: any) => c.key == "idTariff")[0].value;
		var idGeneralTermsAndConditions = this.filters.filter((c: any) => c.key == "idGeneralTermsAndConditions")[0].value;
		var templateCount = this.pricelistTemplate.filter((c: any) => c.idTariff == idTariff).length;
		this.oldIdTariff = idTariff;
		this.oldIdTerm = idGeneralTermsAndConditions;
		return this.tableData.filter((c: any) => c.idTariff == idTariff && c.idGeneralTermsAndConditions == idGeneralTermsAndConditions).length < templateCount;
	}

	oldIdTariff = '';
	oldIdTerm = '';
	createPricelists() {
		this.isBusy = true;
		
		var idTariff = this.filters.filter((c: any) => c.key == "idTariff")[0].value;
		var idGeneralTermsAndConditions = this.filters.filter((c: any) => c.key == "idGeneralTermsAndConditions")[0].value;
		this.formData.idTariff = idTariff;
		this.formData.idGeneralTermsAndConditions = idGeneralTermsAndConditions;
		this.pricelistService.create(this.formData).then(res => {
			if (res.data.isSuccess == true) {
				this.oldIdTariff = idTariff;
				this.oldIdTerm = idGeneralTermsAndConditions;
				this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('pricelist.messageNew').toString());		
			}
			else {
				this.alertModalContent = res.data.errorMessage;
				super.showAlertModalWithErrorMessageList(res.data.errorMessage);
			}
			this.fetchData();
			this.isBusy = false;
		});
	}

	createdBase() {
		this.loadPriceListeTemplate();
	}

	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let pricelistFilter: PricelistFilter = new PricelistFilter(null);
		var allItems = this.pricelistService.getAllByFilter(pricelistFilter);

		allItems.then(response => {
		
		});
		this.loadSpecFilters();
		return allItems;
	}

	loadPriceListeTemplate() {
		 this.pricelistTemplateService.getAllByFilter(new PricelistTemplateFilter()).then(res => {
			 this.pricelistTemplate = res.data;
		});
	}

	loadSpecFilters() {
		this.tariffService.getAll().then(res => {
			this.items = res.data;
			for (var i = 0; i < this.items.length; i++) {
				if (this.typeTariffs.filter((c: any) => c.value == this.items[i].id).length == 0) {
					this.typeTariffs.push({ value: this.items[i].id, text: this.items[i].name, description: this.items[i].name });
				}
			}
			this.typeTariffs = this.typeTariffs.sort((a, b) => a.text.localeCompare(b.text));

			if (Number(this.idType) > 0) {
				this.defaultTariff = this.idType;
			}
			else {
				this.defaultTariff = this.typeTariffs[0].value;
			}
			if (Number(this.oldIdTariff) > 0) {
			
				this.defaultTariff = this.oldIdTariff;
			
			}

			this.generalTermService.getAll().then(res => {
				this.items2 = res.data;
				for (var i = 0; i < this.items2.length; i++) {
					if (this.typeTerms.filter((c: any) => c.value == this.items2[i].id).length == 0) {
						this.typeTerms.push({ value: this.items2[i].id, text: this.items2[i].name, description: this.items2[i].name });
					}
				}
				this.typeTerms = this.typeTerms.sort((a, b) => a.text.localeCompare(b.text));

				if (Number(this.idType) > 0) {
					this.defaultTerms = this.idTerm;
				}
				else {
					this.defaultTerms = this.typeTerms[0].value;
				}

				if (Number(this.oldIdTerm) > 0) {

					this.defaultTerms = this.oldIdTerm;

				}

				this.setfilters(null);
			});
		});

		
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}


	protected prepareItems(items: any[]) {
	};
}